import { Component, OnInit, Input, inject } from '@angular/core';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';

@Component({
    selector: 'app-import-nav',
    templateUrl: './import-nav.component.html',
    imports: [RouterLinkActive, RouterLink]
})
export class ImportNavComponent implements OnInit {
  private route = inject(Router);

  @Input() uploadPath: string;
  @Input() historyPath: string;

  ngOnInit() {
    if (!this.uploadPath && !this.historyPath) {
      const currentPath = this.route.url;
      const pathMatch = currentPath.match(/(.+)(\/history)$/);

      if (pathMatch) {
        this.uploadPath = pathMatch[1];
        this.historyPath = currentPath;
      } else {
        this.uploadPath = currentPath;
        this.historyPath = `${currentPath}/history`;
      }
    }
  }
}
